import { type ApiResponse, type OutreachProspectDto, type OutreachSequenceStep } from '@types';
import { syncApi } from '@lib/apiClients.ts';
import { microServicesRoutes } from '@constants';
interface useOutreachSyncApiReturn {
  getOutreachSequencesSteps: (
    userId: string,
    organizationId: string
  )=> Promise<ApiResponse<OutreachSequenceStep[]>>
  getOutreachProspects: (
      nonce: string,
      sequenceId: number,
      sequenceStepId: number,
      update: boolean
  )=> Promise<ApiResponse<OutreachProspectDto[]>>
}

export function useOutreachSyncApi (): useOutreachSyncApiReturn {
  async function getOutreachSequencesSteps (
    userId: string,
    organizationId: string,
  ): Promise<ApiResponse<OutreachSequenceStep[]>> {
    try {
      const url = `${microServicesRoutes.sync.get.outreach.getSequencesSteps}/${organizationId}/${userId}`;
      const { data } = await syncApi.get<OutreachSequenceStep[]>(url);
      
      return { data, success: true };
    } catch (error: unknown) {
      return { error: { message:
        'Error while getting sequences.',
      }, success: false };
    }
  }

  async function getOutreachProspects (
    nonce: string,
    sequenceId: number,
    sequenceStepId: number,
    update: boolean = false
  ): Promise<ApiResponse<OutreachProspectDto[]>> {
    try {
      const url = `${microServicesRoutes.sync.get.outreach.getProspects}/${nonce}/${sequenceId}/${sequenceStepId}${update ? '?update=true' : ''}`;
      const response = await syncApi.get<OutreachProspectDto[]>(url);

      return {
        data: response.data,
        success: true
      };
    } catch (error: unknown) {
      return { error: { message:
        'Error while getting prospects.',
      }, success: false };
    }
  }

  return {
    getOutreachSequencesSteps,
    getOutreachProspects
  };
}